















































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonCancelButtonTreamentRequestSubmit extends Vue {
  isEditMode = false;
  created() {
    this.isEditMode = this.$route.meta.mode === "EDIT";
  }

  onSaveTreatmentRequest() {
    this.$store.commit("SAVE_TREATMENT_REQUEST_CLICK");
  }

  getRouteCancel() {
    return this.$router.push({ name: "treatment-request" });
  }
}
